/* hunnee PDP interactions */
(function () {
  var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* Feel-word cycler */
  document.querySelectorAll('[data-hn-feel]').forEach(function (wrap) {
    var words = wrap.querySelectorAll('.hn-feel__word');
    if (words.length < 2) { if (words[0]) words[0].classList.add('is-active'); return; }
    var i = 0;
    words[0].classList.add('is-active');
    setInterval(function () {
      var current = words[i];
      i = (i + 1) % words.length;
      current.classList.remove('is-active');
      current.classList.add('is-leaving');
      setTimeout(function () { current.classList.remove('is-leaving'); }, 500);
      words[i].classList.add('is-active');
    }, reduced ? 3200 : 2200);
  });

  /* Sticky ATC: show when the buy form scrolls out of view (replaces %-scroll rule) */
  var stickyBar = document.querySelector('.sticky-atc');
  var buyForm = document.querySelector('form[data-type="add-to-cart-form"]');
  if (stickyBar && buyForm && 'IntersectionObserver' in window) {
    new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (!e.isIntersecting && e.boundingClientRect.top < 0) {
          stickyBar.classList.add('show-sticky');
        } else {
          stickyBar.classList.remove('show-sticky');
        }
      });
    }, { threshold: 0 }).observe(buyForm);
    stickyBar.setAttribute('data-hn-observed', 'true');
  }

  /* Mobile: switching blends keeps your place on the page instead of jumping to the top */
  if (window.matchMedia('(max-width: 989px)').matches) {
    document.querySelectorAll('.flavour-pill').forEach(function (p) {
      p.addEventListener('click', function () {
        try { sessionStorage.setItem('hnPillScroll', String(window.scrollY)); } catch (err) {}
      });
    });
    try {
      var savedY = sessionStorage.getItem('hnPillScroll');
      if (savedY !== null) {
        sessionStorage.removeItem('hnPillScroll');
        var restore = function () { window.scrollTo(0, parseInt(savedY, 10) || 0); };
        restore();
        window.addEventListener('load', restore, { once: true });
      }
    } catch (err) {}
  }

  /* Picker label: "Blend" -> "Functional Honey Supplement" (covers themes whose liquid still says Blend) */
  document.querySelectorAll('.flavour-wrapper h4').forEach(function (h) {
    if (h.textContent.trim() === 'Blend') h.textContent = 'Functional Honey Supplement';
  });

  /* Bundles: no blend picker rendered, but the label still belongs in the same spot */
  if (!document.querySelector('.flavour-wrapper')) {
    var priceEl = document.querySelector('.product__info-container [id^="price-"]');
    if (priceEl) {
      var fw = document.createElement('div');
      fw.className = 'flavour-wrapper';
      var fh = document.createElement('h4');
      fh.textContent = 'Functional Honey Supplement';
      fw.appendChild(fh);
      priceEl.parentNode.insertBefore(fw, priceEl.nextSibling);
    }
  }

  /* Blend pill benefit tagline: shows active blend's line, previews on hover */
  var flavourList = document.querySelector('.flavour-list');
  if (flavourList) {
    var blendMap = {
      'greens': 'daily greens, zero effort',
      'power': 'strength, endurance, clear head',
      'calm': 'unwind, sleep, sweet dreams',
      'energy': 'clean lift, no crash',
      'gut + immunity': 'happy gut, strong defense',
      'matcha': 'no whisk needed',
      'focus': 'deep work, no third coffee',
      'beauty': 'glow from the inside out',
      'sleep': 'the night, owned',
      'starter pack': 'all nine, one of each, find yours'
    };
    var swirlMap = {
      'greens': 'hf_20260719_031606_9f58f602-059d-439c-ad66-00e5e7088d7f.png',
      'energy': 'hf_20260718_234934_ee01c70f-03a6-4347-a235-b42febd569b4.png',
      'power': 'hf_20260718_210054_65b4dbda-2808-45c2-85b4-f47390af604b.png',
      'calm': 'hf_20260719_005445_916a4986-2cc2-41ff-a720-dba1403745dd.png',
      'gut + immunity': 'hf_20260718_210058_460afedb-e4b0-4b2a-a281-bdef05834fec.png',
      'matcha': 'matcha-swirl-dark.png',
      'focus': 'focus-honey-poster.png',
      'beauty': 'hn-swirl-beauty-v3.png',
      'sleep': 'sleep-honey-poster.png',
      'starter pack': 'hf_20260719_144757_acbefb48-3cd5-4a68-b300-f86cf3e7b79c.png'
    };
    var cdnBase = 'https://cdn.shopify.com/s/files/1/0779/1457/0967/files/';
    var tagEl = document.createElement('p');
    tagEl.className = 'hn-blend-tag';
    flavourList.insertAdjacentElement('afterend', tagEl);
    var pills = flavourList.querySelectorAll('.flavour-pill');
    pills.forEach(function (p) {
      var k = p.textContent.trim().toLowerCase();
      if (swirlMap[k] && !p.querySelector('.hn-pill-swirl')) {
        var wrap = document.createElement('span');
        wrap.className = 'hn-pill-swirl';
        var img = document.createElement('img');
        img.src = cdnBase + swirlMap[k] + '?width=400';
        img.alt = '';
        img.loading = 'lazy';
        img.width = 400;
        img.height = 400;
        wrap.appendChild(img);
        p.prepend(wrap);
      }
    });
    var activePill = flavourList.querySelector('.flavour-pill.active');
    var keyOf = function (p) { return p.textContent.trim().toLowerCase(); };
    var setTag = function (k) { tagEl.textContent = blendMap[k] || ''; };
    setTag(activePill ? keyOf(activePill) : '');
    pills.forEach(function (p) {
      p.addEventListener('mouseenter', function () { setTag(keyOf(p)); });
      p.addEventListener('mouseleave', function () { setTag(activePill ? keyOf(activePill) : ''); });
    });
  }

  /* Count-up stat tiles */
  var counters = document.querySelectorAll('[data-hn-count]');
  if (counters.length && 'IntersectionObserver' in window && !reduced) {
    var seen = new WeakSet();
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (!e.isIntersecting || seen.has(e.target)) return;
        seen.add(e.target);
        var el = e.target;
        var target = parseFloat(el.getAttribute('data-hn-count')) || 0;
        var start = null;
        var dur = 1200;
        function tick(ts) {
          if (!start) start = ts;
          var p = Math.min((ts - start) / dur, 1);
          el.textContent = Math.round(target * (1 - Math.pow(1 - p, 3)));
          if (p < 1) requestAnimationFrame(tick);
        }
        requestAnimationFrame(tick);
        io.unobserve(el);
      });
    }, { threshold: 0.4 });
    counters.forEach(function (c) { io.observe(c); });
  } else {
    counters.forEach(function (c) { c.textContent = c.getAttribute('data-hn-count'); });
  }
})();
